import SparseTable from './SparseTable';

export default SparseTable;
